import { cn } from '@/lib/utils';

/**
 * Text wordmark echoing the Anchor Transportation logo: heavy italic, uppercase,
 * "ANCHOR" in brand red against an ink "COMMS". Used in the header and sign-in.
 */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'font-display font-black uppercase italic tracking-tight leading-none select-none',
        className,
      )}
    >
      <span className="text-anchor">Anchor</span>
      <span className="text-ink"> Comms</span>
    </span>
  );
}
